import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class StoredModelSectionModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (StoredModelSectionModel._instance == null) StoredModelSectionModel._instance = new StoredModelSectionModel(authManager);
        return StoredModelSectionModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/stored-model-sections');

        this.entityName = 'model-sections.StoredModelSection';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Stored Model Section';
        this.setLabel = 'Stored Model Sections';

        this.browser = {
            name: 'default-model-sections-storedmodelsection-browser',
            moduleName: 'default-model-sections-storedmodelsection-browser',
            moduleTitle: 'Stored Model Sections',
            moduleStateSlotName: 'default-model-sections-storedmodelsection-browser',
        };

        this.editor = {
            name: 'default-model-sections-storedmodelsection-editor',
            moduleName: 'default-model-sections-storedmodelsection-editor',
            moduleTitle: 'Stored Model Section',
            moduleStateSlotName: 'default-model-sections-storedmodelsection-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
            },
            {
                name: 'projectId',
                type: 'Project',
                persistent: true,
                label: 'Project',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'data',
                type: 'text',
                persistent: true,
                label: 'Data',
            },
        ];

    }

}
